import React from 'react'
import PropTypes from 'prop-types'
import Touchpoint from './Touchpoint'
import classnames from 'classnames'

export default class Touchpoints extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    disabled: PropTypes.bool
  }

  render() {
    const {items, disabled} = this.props

    const classNames = classnames('orders-view_orders-table-touchpoints', {
      'is-disabled': disabled
    })

    const itemGroups = items.reduce((acc, touchpoint) => {
      if (touchpoint.impressions && touchpoint.impressions.length) {
        acc.push([touchpoint])
      } else if (
        acc.length &&
        acc[acc.length - 1][0].channel === touchpoint.channel &&
        acc[acc.length - 1][0].channelGroup === touchpoint.channelGroup
      ) {
        acc[acc.length - 1].push(touchpoint)
      } else {
        acc.push([touchpoint])
      }

      return acc
    }, [])

    return (
      <div className={classNames}>
        {itemGroups.map((touchpoints, groupIndex) => {
          if (touchpoints.length >= 5) {
            return (
              <>
                <Touchpoint
                  active
                  touchpoint={touchpoints[0]}
                  key={groupIndex}
                  disabled={disabled}
                />
                <div className='orders-view_touchpoint_group'>{`... ${
                  touchpoints.length - 1
                } more`}</div>
                {groupIndex < itemGroups.length - 1 && (
                  <div className='orders-view_touchpoint_link' />
                )}
              </>
            )
          } else {
            return touchpoints.map((touchpoint, itemIndex) => {
              return (
                <>
                  <Touchpoint
                    active
                    touchpoint={touchpoint}
                    key={`${groupIndex}-${itemIndex}`}
                    disabled={disabled}
                  />
                  {!(
                    groupIndex === itemGroups.length - 1 &&
                    itemIndex === touchpoints.length - 1
                  ) && <div className='orders-view_touchpoint_link' />}
                </>
              )
            })
          }
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/Touchpoints.js